/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { GlobalVar } from 'vmf';
import { Sv } from './Sv';

class ExamPaperExperience extends Sv {
    constructor() {
        super();
        this.baseUrl += '/examPaperExperience';
    }

    data({ ids, examName, schoolOrgId, currentPage, pageSize } = {}, config) {
        return super.get(
            '/data',
            {
                ids,
                examName,
                schoolOrgId,
                currentPage,
                pageSize,
            },
            {
                ...config,
            },
        );
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { examImage } = json.data.data.examPaperExperience;
            if (!examImage) {
                json.data.data.examPaperExperience.examImage = [];
            } else {
                json.data.data.examPaperExperience.examImage = examImage.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({ id, paperTemplateId, examName, examImage, examTime, examNum, orderNum, isAvailable, schoolOrgId } = {}) {
        const examImageStr = examImage
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            id,
            paperTemplateId,
            examName,
            examImage: examImageStr,
            examTime,
            examNum,
            orderNum,
            isAvailable,
            schoolOrgId,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    changeIsAvailable({ id, isAvailable } = {}) {
        return super.post('/changeIsAvailable', {
            id,
            isAvailable,
        });
    }
}

export default new ExamPaperExperience();
export { ExamPaperExperience };
